export default __webpack_public_path__ + "static/media/IMG4221_r.6f72773a.jpg";